import { css } from '@emotion/css';

export const dnsRecordInstructionsClassName = css({
  minWidth: 650,
});
